import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DxDataGrid, {
  DxColumn,
  DxFilterRow,
  DxPaging, DxPager,
  DxHeaderFilter,
  DxStateStoring,
  DxButton,
} from "devextreme-vue/data-grid";
import { onMounted, ref } from "vue";
import { ProjectItem } from "@/services/entities/ProjectItem";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectTable',
  props: {
  projects: { Type: [] as ProjectItem[], default: [] as ProjectItem[] },
},
  emits: ["detail"],
  setup(__props, { emit: __emit }) {

const emit = __emit;

const selectedKeys = ref([] as number[]);

const props = __props;
function showDetail(e: any) {
  selectedKeys.value = [e.row.data.id];
  emit("detail", e.row.data.id);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DxDataGrid), {
    "hover-state-enabled": true,
    "show-borders": false,
    "data-source": props.projects,
    id: "project-table",
    "selected-row-keys": selectedKeys.value,
    "auto-navigate-to-focused-row": true,
    "key-expr": "id"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(DxFilterRow), { visible: true }),
      _createVNode(_unref(DxHeaderFilter), { visible: true }),
      _createVNode(_unref(DxStateStoring), {
        enabled: true,
        type: "localStorage",
        "storage-key": "project-table"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "projectName",
        "data-type": "string",
        caption: "Project name"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "projectNumber",
        "data-type": "string",
        caption: "Project number"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "service.blServiceName",
        "data-type": "string",
        caption: "Service"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "projectType",
        "data-type": "string",
        caption: "Project type"
      }),
      _createVNode(_unref(DxColumn), {
        "data-field": "isActive",
        "data-type": "boolean",
        caption: "Active"
      }),
      _createVNode(_unref(DxColumn), {
        type: "buttons",
        caption: "Actions",
        width: 70
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DxButton), {
            hint: "View detail",
            icon: "eyeopen",
            "styling-mode": "contained",
            type: "normal",
            onClick: showDetail
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(DxPaging), { "page-size": 10 }),
      _createVNode(_unref(DxPager), {
        "show-page-size-selector": true,
        "allowed-page-sizes": [5, 10, 20]
      })
    ]),
    _: 1
  }, 8, ["data-source", "selected-row-keys"]))
}
}

})